"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = exports.Success = void 0;
var Success = function (result) { return ({ status: 'success', result: result }); };
exports.Success = Success;
var Error = function (error) { return ({ status: 'error', error: error }); };
exports.Error = Error;
//# sourceMappingURL=BaseRpcTypes.js.map